/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VmuaEntityKeyInfo } from './vmuaEntityKeyInfo';


/**
 * Complete details of a registered entity including its metadata and associated key pairs. Combines data from vvmua_entities and vvmua_keys tables.
 */
export interface VmuaEntityDetails { 
    /**
     * Unique identifier of the entity (e.g. vCenter UUID).
     */
    entityId?: string;
    /**
     * Human-readable display name of the entity (e.g. vcenter3.acme.com).
     */
    displayName?: string;
    /**
     * Current version of the entity software.
     */
    version?: string;
    /**
     * Entity-specific metadata as free-form JSON (e.g. buildNo).
     */
    metadata?: { [key: string]: any; } | null;
    /**
     * Current status of the entity (e.g. ACTIVE).
     */
    status?: string;
    /**
     * Timestamp when the entity was first registered.
     */
    createdTs?: Date;
    /**
     * Timestamp of the last entity update.
     */
    updatedTs?: Date;
    /**
     * User who first registered the entity.
     */
    createdBy?: string;
    /**
     * User who last updated the entity.
     */
    updatedBy?: string;
    /**
     * Array of all RSA key pairs associated with this entity. Includes the current active key and any keys in grace/expired state.
     */
    keys?: Array<VmuaEntityKeyInfo>;
}

